export { default as layout } from './layout/'
import Page from './page/'
import setPriorities from './set-priority/'

export const page = {
  ...Page(),
  setPriorities
}
